import type { PortalDeclined, PortalDog } from '@bbbk/schema';
import { PendingButton } from '../components/common/PendingButton';
import { G } from './glyphs';
import { declinedTitle, dogsOn, opener, type Notice } from './homeRules';
import { whatsappHref } from './whatsapp';
import { dogsPath, payPath } from './landing';

// G23 · the top of Home: *Needs you · n* over a card per thing standing between
// the customer and the stay — the mark in the tone's colour, the sentence with
// its lead in bold, the door at the end of the row. The section keeps its name
// when it is empty (decision 241): a heading that comes and goes makes the
// customer hunt for where the thing they remember lived.

const ICON = { warn: G.warn, syringe: G.syringe, euro: G.euro };
// The money doors read Upload (Freddi, 2026-10-11): the sheet is where they transfer AND prove it, and the proof is the act Home asks for.
const DOOR_LABEL = { deposit: 'Upload', balance: 'Upload', upload: 'Upload', view: 'View' };
// A card's doors open the dogs drawer on that dog (vaccination-cards AC1); the money's, the pay sheet.
const doorPath = (n: Notice) => (n.door === 'upload' || n.door === 'view' ? dogsPath(n.dogId) : payPath(n.stay?.id ?? ''));

export function Notices({ items, contactName, dogs = [], declined = [], head = 'Needs you', onGo }: { items: readonly Notice[]; contactName: string; dogs?: readonly PortalDog[]; declined?: readonly PortalDeclined[]; head?: string; onGo?: (path: string) => void }) {
  const count = items.length + declined.length;
  return (
    <>
      <p className="cp-eyebrow nd-head">
        {head}
        {count > 0 && ` · ${count}`}
      </p>
      {/* A DECLINE LEADS (c3no2): red, the dogs and the dates, Nothing was
          charged, and no door — there is nothing to do but book again, and
          the page's own Book a stay is that act (decision 270: one door). */}
      {declined.map((d) => (
        <div key={'declined' + d.id} className="cp-card msg msg-alert is-declined">
          <span className="msg-ic">{G.ban({ size: 15 })}</span>
          <div className="msg-txt">
            <b>{declinedTitle(d)}</b>
            <small>Nothing was charged</small>
          </div>
        </div>
      ))}
      {count === 0 ? (
        <div className="nd-empty">
          {G.paw({ size: 14 })}
          Nothing needs you right now
        </div>
      ) : (
        items.map((n) => (
          <div key={n.door + (n.stay?.id ?? '') + (n.dog ?? '')} className={`cp-card msg msg-${n.tone} has-act`}>
            <span className="msg-ic">{ICON[n.ico]({ size: 15 })}</span>
            <div className="msg-txt">
              <b>{n.title}</b>
              <small>{n.detail}</small>
            </div>
            {/* The door opens Message Patricia with a line naming the thing
                until its own row ships (AC5a, open question 1). */}
            {/* THE MONEY DOORS OPEN THE PAY SHEET (deposit-proof AC1a, AC18);
                a card's Upload and View open the dogs drawer (vaccination-cards AC1). */}
            {onGo ? (
              <PendingButton className="msg-act" onClick={() => onGo(doorPath(n))}>
                {DOOR_LABEL[n.door]}
                {G.chevRight({ size: 14, className: 'chev' })}
              </PendingButton>
            ) : (
              <PendingButton
                className="msg-act"
                href={whatsappHref(opener(n.door, { contactName, dogs: n.stay ? dogsOn(n.stay, dogs).names : dogs.map((d) => d.name), ...(n.stay ? { stay: n.stay } : {}), ...(n.dog ? { dog: n.dog } : {}) }))}
                external
              >
                {DOOR_LABEL[n.door]}
                {G.chevRight({ size: 14, className: 'chev' })}
              </PendingButton>
            )}
          </div>
        ))
      )}
    </>
  );
}
